import type { JSX } from "react";
import type { DeviceProfile } from "../types";
import { formatDate, formatNumber } from "./format";

type Stat = { label: string; value: string };

const StatTile = ({ label, value }: Stat): JSX.Element => (
  <div className="rounded-(--radius-md) bg-(--surface-2) px-4 py-3">
    <p className="text-[11px] font-semibold uppercase tracking-wide text-(--text-muted)">
      {label}
    </p>
    <p className="mt-1 text-[15px] font-semibold text-(--text-primary)">
      {value}
    </p>
  </div>
);

export const OverviewPanel = ({
  profile,
}: {
  profile: DeviceProfile;
}): JSX.Element => {
  const stats: Stat[] = [
    { label: "VAST count", value: formatNumber(profile.vastCount) },
    { label: "First seen", value: formatDate(profile.range?.firstSeen) },
    { label: "Last seen", value: formatDate(profile.range?.lastSeen) },
    { label: "Distinct IPs", value: formatNumber(profile.ips.length) },
    { label: "Distinct UAs", value: formatNumber(profile.userAgents.length) },
    { label: "Tag count", value: formatNumber(profile.tags.length) },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {stats.map((stat) => (
        <StatTile key={stat.label} {...stat} />
      ))}
    </div>
  );
};
